export function getOnboardingTermsZhMarkdown({
  organizationName,
  organizationAddress,
}: {
  organizationName: string
  organizationAddress: string
}): string {
  return `## **ARTEM LEX - 软件服务协议**

## 协议双方

- ARTEM Technologie AG（地址：瑞士楚格州查姆市辛瑟大街67号，邮编6330，**以下简称**"服务提供商"）；与
- ${organizationName}，${organizationAddress}（以下简称"客户"）。

上述第(1)至(2)项所述各方以下统称为**"双方**"，单独称为"**一方**"。

---

## 1. 定义

在本协议中，下列术语具有以下定义含义：

- "协议"指本软件即服务协议。
- "指定机构"指由政府主管部门指定的组织，负责评估特定产品是否符合具体的法律和监管要求，以确定其是否可在特定市场投放。
- "服务"指本协议**附件1中**规定的软件的功能和性能特征，以及客户需满足的系统要求。
- "软件"指"ARTEM Lex"软件。
- "**订阅**期"是指自试用期届满或终止之日起开始、直至本协议终止为止的无限期期间，在此期间，客户有权访问和使用软件，并应根据本协议支付报酬。
- "试用期"是指客户根据第§ 条3 规定，在有限时间内试用软件的初始期间。

## 2. 服务范围

- 服务提供商将在本协议规定的期限内，并根据本协议向客户以"软件即服务"（SaaS）的形式提供软件。
- 该软件应包含服务中规定的功能和特性。
- 本软件仅以机器可读形式（目标代码）提供。源代码不属于本协议的主题，且不会交付。
- 客户知悉，本软件依赖于客户和/或第三方提供的信息和数据。提供商无法控制此类信息和数据，因此无法确保此类信息和数据的准确性或完整性，以及本软件的结果。
- 对于通过本软件生成、显示、传输或以其他方式提供的任何陈述、意见、内容、输出或责任表述，服务提供商不作任何明示或暗示的陈述、担保或保证，包括其准确性、完整性、可靠性、合法性或正确性。所有此类陈述和表述仅供参考，用户使用需自行承担全部风险。 提供商明确声明，不保证此类陈述或表述能准确反映法律义务、责任或结果。
- 客户知悉，通过本软件生成的文档和报告依赖于客户及第三方提供的准确信息和数据。因此，提供商不保证或担保通过本软件生成的任何报告或文档能够通过指定机构或任何其他第三方的验证。
- 向欧盟或任何政府机构提交信息的任何义务完全由客户承担。提供商对向欧盟或任何其他政府机构提交任何信息不承担任何义务。
- 本软件的可用性以及与本软件相关的支持服务，详见本协议**附件2**。
- 服务提供商每天会在技术上独立的系统上创建一次完整的数据备份。数据备份将至少保留7天。每15分钟进行一次增量备份（ ），以减少发生故障时的数据丢失。增量备份不会复制到独立的系统上。

## 3. 试用期 与订阅期

- 本协议自双方签署之日起生效，有效期为不定期，包括：
  - 试用期；以及
  - 订阅期。
- 在试用期内：
  - 服务提供商将向客户授予有限期的试用权限，自本协议签署之日起算，最长为7天，除非任一方提前终止。
  - 本软件按"原样"和"可用"状态提供，不作任何明示、默示、法定或其他形式的保证，包括但不限于适销性、特定用途适用性或不侵权的保证。服务提供方不保证在试用期内本软件将始终可用、不中断、无错误或满足客户的要求。
  - 提供商可随时修改、暂停或终止试用期，无论是否发出通知。客户可在试用期内随时停止使用本软件。
  - 除非另有书面约定，客户在试用期内使用本软件无需支付任何报酬或其他费用。
  - 在法律允许的最大范围内，提供方对客户在试用期内使用本软件所引起或与之相关的任何责任概不负责。
- 在试用期内，客户可随时通过向提供商发出书面通知，选择购买该软件的订阅服务。在提供商接受该选择后：
  - 试用期即告终止；且
  - 本协议将在试用期届满后立即开始的订阅期内继续完全有效，且 客户有义务支付本协议项下的适用报酬。
- 若服务提供商在试用期届满前未收到客户根据上述第(3)条发出的选择购买订阅服务的书面通知，本协议将于试用期届满时自动终止，且客户对软件的访问权限将随之终止。

## 4. 使用范围

- 提供商将授予客户非独占、不可再许可、不可转让的权利，该权利在时间上限于本协议的期限，允许客户在其业务运营范围内，根据本协议使用软件（包括任何更新）。
- 未经提供商许可，客户无权将软件转让给第三方（例如出售或出租软件），或以其他方式使第三方使用该软件。以非提供商合同伙伴的第三方名义或为该第三方利益使用软件，亦视为对软件的未经授权使用。此规定同样适用于客户的关联公司。
- 客户无权对软件进行修改。根据《德国著作权法》（UrhG）第69d条和第69e条规定的法定权利不受影响。仅当客户提出请求后，供应商未在合理期限内提供必要信息时，客户才有权依据《德国著作权法》第69e条行使相关权利。

## 5. 客户的配合义务

- 客户应独自负责确保具备足够的互联网连接以使用本软件。
- 客户有义务保护其被分配的访问权限以及身份识别和认证信息，防止第三方访问，且不得将其透露给未经授权的人员。若出现迹象表明未经授权的第三方知晓其被分配的访问权限及身份识别和认证信息，客户应立即通知服务提供商。
- 客户不得向本软件提交或上传任何违反适用法律、侵犯第三方权利或感染病毒或恶意软件的数据、信息或其他内容（**"**内容"）。特别是，客户有责任确保其拥有在本软件中使用任何内容的充分版权。
- 客户声明并保证，通过其账户提交至本软件的所有内容均准确无误。客户还声明，其拥有客户提交或上传至本软件的内容所需的一切必要权利。
- 客户授予服务提供商在提供本协议规定服务所必需的范围内，复制由服务提供商根据本协议存储的数据的权利。服务提供商亦有权将数据保存在备份数据中心。为避免服务中断，服务提供商亦有权对数据结构或数据格式进行修改。
- 如果客户违反第(2)条或(3) 规定的义务，或者发生安全事件，服务提供商有权完全或部分、暂时或永久地暂停客户对软件的访问权限。 服务提供商将通过电子邮件通知客户。一旦访问权限被暂停，客户在暂停期间使用软件的权利即告终止。服务提供商在决定是否暂停访问时，将考虑客户的合法权益，特别是当有迹象表明客户对违约行为不负责任时。一旦暂停访问的原因不复存在，服务提供商将立即恢复访问权限。
- 若因客户违反(3) 规定导致内容丢失，服务提供商不承担任何责任。客户应就因违反(3) 规定而产生的所有费用及成本向服务提供商进行赔偿。
- 客户应指派具备专业能力的员工，以书面形式（若通过电话沟通则需事后补交）尽可能清晰地记录所发生的任何错误/缺陷，详细说明其发生情况、影响以及（在客户能够就此作出陈述的情况下）可能的原因，并在发现后立即向服务提供商报告。
- 若因违反本条款规定的义务而导致第三方提出索赔、产生费用及成本，客户应就此向服务提供商提供赔偿§ 3 。服务提供商将就此类索赔通知客户，从而在法律允许且合理的范围内，为客户提供针对所主张索赔进行抗辩的机会。客户应立即向服务提供商 提供其掌握的、构成索赔依据的所有相关事实信息。此举不影响服务提供商主张的任何进一步赔偿请求。

## 6. 报酬与付款条款

双方同意本协议**附件3**所载的报酬及付款条款。

---

## 7. 瑕疵权利

- 客户应立即将软件的任何缺陷通知服务提供商，并以可重现的方式说明错误或缺陷发生的方式及具体情形。客户应积极协助服务提供商排查缺陷，特别是提供服务提供商为分析和消除缺陷所需的所有其他必要文件和数据。
- 对于仅导致性能适用性轻微降低的情况，不承担保修责任。对于在协议订立时已存在的缺陷，不适用《德国民法典》（_Bürgerliches Gesetzbuch_ "BGB"）第536a条第1款第1项规定的无过错责任。
- 若出现缺陷，附件 3 所列的报酬费用不会自动减少（《德国民法典》第 536 条）。就此而言，客户无权因租赁标的物的缺陷而通过从附件 3 所列的约定报酬费用中扣除或与租赁标的物相关的后续索赔进行抵销来获得减额，而必须向服务提供商单独主张这些索赔。
- 如果客户修改软件或由第三方修改软件，则客户无权行使任何缺陷权利，除非客户证明该修改并非缺陷的原因。

## 8. 责任

- 本协议中的任何内容均不会限制或排除提供方的责任：(a) 因故意或重大过失造成的损害；(b) 涉及生命、身体或健康（ ）的伤害；(c) 根据《德国产品责任法》（_Produkthaftungsgesetz_）的规定。
- 对于因一般过失违反对实现本协议目的至关重要且客户依赖并有权依赖其履行的合同义务（主要合同义务*--Kardinalpflichten*）的情况，提供方的责任在金额上将限于可预见的典型损害。
- 此外，无论法律依据如何，提供商因本协议引起或与本协议有关的责任，在一般过失的情况下，应限于客户根据本协议支付的报酬总额。
- 上述责任限制同样适用于服务提供商的代理人的利益。

## 9. 终止

- 任何一方均可随时通过书面通知，提前 30 天终止本协议。
- 双方因正当理由无需通知即可终止本协议的权利不受影响。特别是以下情况应视为存在正当理由：
  - 另一方持续且反复违反本协议项下的义务，且在收到及时通知要求其停止违约行为后仍未终止其违反合同义务的行为；
  - 客户未按§ 6 支付至少两个月的报酬，或未支付该报酬中相当大的一部分；或
  - 针对另一方的资产已启动破产程序，或因资产不足而被驳回破产程序的申请。
- 无论何种情况，终止通知均须以书面形式发出，电子形式亦符合此要求（《德国民法典》第126a条）。
- 协议终止 30 天后，服务提供商应不可逆地删除其服务器上剩余的所有客户数据，除非客户在此期间以书面形式通知服务提供商将数据返还给客户。

## 10. 保密

- 双方承诺对第三方严格保密，且/或不向第三方披露其通过使用软件从对方处获得或能够查阅的任何信息，以及任何标注为机密的信息。特别是，客户应以未经授权人员无法访问的方式存储从服务商处收到的所有信息。 双方应针对保密信息采取适当的保密措施。仅在"需要知悉"的基础上向员工提供保密信息。客户应对其员工施加相应的保密义务。
- 根据§ 8 (1) 规定的保密义务，在本协议到期之日起两年内继续有效。根据§ 8 (1) 规定的保密义务不适用于：
  - 依法或经披露方许可而获知相关信息且受保密义务约束的人员，
  - 对于已为公众所知或因非另一方责任而为公众所知的文件和/或信息，
  - 对于接收方通过经授权披露的第三方所获知的文件和/或信息，以及/或，
  - 在保密义务妨碍接收方主张权利的范围内，以及/或因法定规定和/或官方命令而接收方可要求公开的范围内，以及/或《商业秘密法》（_Geschäftsgeheimnisgesetz_）第3条、第5条对接收方有利的范围内。
- 接收方必须证明上述例外情形之一的存在。

## 11. 数据保护

- 客户承诺遵守适用的数据保护法律规定，并要求其员工遵守这些规定。
- 双方同意，在协议范围内，服务提供商不代表客户处理个人数据。但是，如果服务提供商和客户有必要就个人数据保护签订补充协议（例如根据《通用数据保护条例》（GDPR）第 28 条签订的数据处理协议），双方应签订此类协议。

## 12. 转让与抵销

- 未经另一方事先书面同意，任何一方均无权转让本协议项下的任何权利或索赔。
- 除非本协议另有明确规定，任何一方均无权 (i) 以其根据本协议享有的任何债权抵销任何其他方的债权，或 (ii) 通过主张留置权而拒绝履行本协议项下的任何义务，除非主张抵销权或留置权的一方的权利或债权是无可争议的，或已由有管辖权的法院或仲裁庭的终局裁决予以确认，或 - 若为程序性主张 - 该方的权利或索赔可在最后一次口头听证时一并裁决。

## 13. 最终条款

- 双方均有权向第三方指明对方为参考合同伙伴，并在此情况下使用对方的徽标。
- 对于因不可抗力（即双方均无法控制的情况）导致的履行延迟，各方不承担对另一方的责任。
- 本合同的任何修改和补充必须以书面形式作出方为有效，电子形式亦符合此要求（《德国民法典》第126a条）。此规定同样适用于对本书面形式条款的任何修改。
- 本协议及其解释应受德意志联邦共和国法律管辖。《联合国国际货物销售合同公约》（CISG）不适用。因本协议引起或与本协议有关的权利和义务（包括其效力）所产生的所有争议，均以柏林为专属管辖地。
- 本合同中一项或多项条款的无效或不可执行，不影响本协议其余条款的有效性。若协议中未包含某项本身必要的条款，亦适用此规定。除非合同的补充解释具有优先效力或可行，否则双方应以尽可能接近该无效或不可执行条款经济目的的有效条款予以替代。


## 附件1 - 服务

### A.1

软件的特性与功能

该软件具有以下特点：

| 功能      | 描述                                                                                             |
| --------- | ------------------------------------------------------------------------------------------------ |
| LEX Radar | 基于客户指定的信息以及客户上传的文件，本软件将向客户提供一份可能适用于其产品的欧盟法规参考清单。 |
| LEX 向导  | 本软件为客户提供了具体的引导流程，指导客户完成可能适用于其产品的每项法规的合规步骤。             |
| Lex 文档  | 本软件生成文件草稿，以协助记录法规合规情况。                                                     |

### A.2.

系统架构与部署模型

双方同意，服务将按以下方式采用托管式多租户模式：

| 云类型     | 公有云 |
| ---------- | ------ |
| 托管服务商 | 阿里云 |

#### A.2.1. 性能与可扩展性

该架构具有以下性能和可扩展性特征：

- 具备自动扩展能力的企业级工作负载。
- 基于 Kubernetes 的架构支持水平自动扩展，可根据实时需求动态调整资源，以在流量高峰期间保持最佳性能。
- 跨多个可用区进行负载均衡，并可随业务增长灵活扩展，确保服务不中断。

#### A.2.2. 网络安全和运营合规性

该架构具备以下网络安全和运营特性：

- 所有数据在传输过程中均采用 TLS 1.3 加密，在数据库和存储层静止时均采用 AES-256 加密。
- 基于角色的访问控制 (RBAC) 提供安全的身份和访问管理，确保对操作员和申报人用户类型进行细粒度的权限管理。
- 支持通过 SAML 2.0 集成单点登录（SSO），实现与主流身份提供商（Azure AD、Okta、Google Workspace 等）的无缝认证。
- 符合 GDPR 要求，具备数据驻留控制、被遗忘权功能及全面的审计日志记录。阿里云基础设施已获得 ISO 27001、ISO 27017 和 SOC 2 Type II 认证。

#### A.2.3. 集成与 API

该架构具有以下集成与 API 功能：

- 软件平台基于采用 HTTPS 和 JSON 的 RESTful API 构建，目前为我们的软件客户端应用程序提供支持。
- 该软件会根据客户需求主动评估集成请求--路线图中包括针对 Oracle Logistics、SAP ERP 及类似企业平台的连接器。

#### A.2.4 数据治理与管理

该架构具备以下数据治理与管理功能：

- 存储：具有可扩展容量的区域性 PostgreSQL 数据库
- 备份：自动每日备份，保留 7 天，支持特定时间点恢复
- 灾难恢复：RPO 为 24 小时，RTO 为 2-4 小时（实现完全恢复）
- 数据保留：根据监管要求（符合GDPR）配置保留期限
- 数据删除：安全的删除流程，确保应要求彻底清除数据

#### A.2.5 服务可用性与可靠性

- 99.5% 的正常运行时间 SLA，通过 Better Stack 持续监控基础设施和应用程序，并通过 Sentry 主动检测错误。
- 自动警报确保 24/7 的事件检测和响应能力，以维持服务稳定性。

#### A.2.6 定制能力

根据客户的业务流程和工作流进行定制，包括用户角色和权限的配置。

其他合理的定制化请求可根据具体情况逐案考虑。

### A.3.

**维护**

| **项目项目**                                         | **内容**                                                     |
| ---------------------------------------------------- | ------------------------------------------------------------ |
| 集中式项目管理                                       | 由专职项目经理负责监督所有客户实体的协调工作 确保符合监管时间表、数据集成里程碑及利益相关方的期望 |
| 针对各实体的入职培训                                 | 为每个实体提供定制化的入职培训 互动式培训（线上或线下），并配有后续问答环节 |
| 客户成功与反馈机制                                   | 每季度与各实体举行评审会议，评估绩效、收集反馈并规划改进措施 配备专属客户成功经理，确保客户满意度并持续改进 |

---

## 附件2：支持

1. 服务提供商承诺在确保软件可用性的范围内提供更新。更新通常包括错误修正或其他轻微改进，不包含重大新功能。
2. 供应商有权在不事先通知的情况下对软件进行修改，前提是此类修改旨在维护和/或改进软件。为此，更新和/或升级将自动安装在供应商的服务器上。若此类变更对客户的使用行为和/或从技术角度造成影响，供应商将提前通知客户（如有必要，亦可通过供应商指定的网站进行通知）。
3. 服务提供商将在工作时间内通过电子邮件向客户提供支持（"支持"）。此项服务旨在协助客户解决使用软件时可能遇到的任何困难。 服务提供商的营业时间为工作日（周一至周五）的工作时段（09:00（中欧夏令时）- 17:00（中欧夏令时）），不包括瑞士的公共假期以及每年的12月24日和12月31日（"营业时间"）。支持服务的提供每月限额为30小时。
4. 在合同有效期内，服务提供商应持续监控软件的功能，并根据合同条款消除影响使用的错误。错误的消除可通过安装新更新来实现（通常在非工作时间进行--对于1类错误，也可在工作时间内进行）。若客户按合同约定提交了正确的错误报告，服务提供商承诺在工作时间内提供以下响应时间：

| **错误等级**                                                          | **响应时间**                         |
| --------------------------------------------------------------------- | ------------------------------------ |
| 错误等级1： 软件无法使用。                                             | 自通过电子邮件收到错误报告起24小时内 |
| 错误类别 2： 软件的核心功能无法使用，或仅能以非常有限的范围使用。     | 自通过电子邮件收到错误消息起48小时内 |
| 错误等级 3： 其他缺陷                                                 | 自通过电子邮件收到错误报告起72小时内 |

---

## 附件 3：报酬与付款条款

1. 免费试用期结束后，若客户同意购买本软件，则根据本协议应支付的服务报酬为**月度订阅费**。
2. （**“月度订阅费”**）：若客户同意购买本软件，客户应支付使用该软件的月度报酬。月度报酬应在初始期限内每年提前开票，并须在发票开具后三（3）日内支付。

3. 所有金额均需加收适用的法定增值税。

`
}
